import events from "../../constants/events";
import breakpoints from "../../constants/breakpoints";
import { dispatchEvent } from "../../utilities/customEvents";
import { initBehaviors, destroyBehaviors } from "../";

import { Base } from "./Base";

import { disableBodyScroll, enableBodyScroll } from "body-scroll-lock";

const classes = {
  overlayOpen: "overlay-open",
};

const body = document.body;

export class Overlay extends Base {
  constructor(behaviorName, element) {
    super(behaviorName, element);
    this.initialClasses = [];
    this.preventClose = false;
    this.init();
  }

  init() {
    this.cacheInitialClasses();
    this.bindOpenListener();
    this.bindCloseListener();
    this.handleCloseClick();
    this.handleBackgroundClick();
  }

  cacheInitialClasses() {
    this.initialClasses = this.element.className;
  }

  bindOpenListener() {
    this.openHandler = this.openOverlay.bind(this);
    window.addEventListener(events.OPEN_OVERLAY, this.openHandler);
  }

  bindCloseListener() {
    this.closeHandler = this.closeOverlay.bind(this);
    window.addEventListener(events.CLOSE_OVERLAY, this.closeHandler);
  }

  openOverlay(e) {
    const { title, content, contentContainer, footer } = this.refs;
    const { target, titleText, variants, preventClose, subAnchor, link } =
      e.detail;

    // Create content
    if (target && content) {
      content.innerHTML = document.getElementById(
        target.split("#")[1]
      ).innerHTML;

      if (subAnchor && content.querySelector(subAnchor)) {
        content.innerHTML = content.querySelector(subAnchor).innerHTML;
      }
      initBehaviors(content);
      document.dispatchEvent(new CustomEvent("appMount"));
    }

    // Set title text
    if (title) {
      if (titleText) {
        title.innerHTML = titleText;
      } else {
        title.innerHTML = "";
      }
    }

    // Set footer link
    if (footer) {
      if (link) {
        footer.innerHTML = `<a href="${link.url}">${link.text}</a>`;
      } else {
        footer.innerHTML = "";
      }
    }

    // Unset variant classes
    this.element.className = this.initialClasses;

    // Set variant classes
    if (variants) {
      const variantArray = variants.split(" ");

      for (let i = 0; i < variantArray.length; i++) {
        this.element.classList.add(variantArray[i]);
      }
    }

    body.classList.add(classes.overlayOpen);

    // Handle prevent close
    if (preventClose) {
      this.preventClose = preventClose;
    }

    // Disable body scroll
    if (window.innerWidth >= breakpoints.MD) {
      disableBodyScroll(contentContainer, { reserveScrollBarGap: true });
    }

    // Bind escape key handler
    this.handleEscapeKey();

    // Dispatch overlay opened event
    dispatchEvent(window, events.OVERLAY_OPENED);

    // Dispatch reveal items added listener
    dispatchEvent(window, events.REVEAL_ITEMS_ADDED);

    let isWide = false;
    if (content.getElementsByClassName("size-guide").length >= 1) {
      this.element.classList.add("full-wide");
    } else {
      this.element.classList.remove("full-wide");
    }
  }

  handleCloseClick() {
    const { close } = this.refs;

    if (close) {
      close.addEventListener("click", (e) => {
        e.preventDefault();
        this.closeOverlay();
      });
    }
  }

  handleBackgroundClick() {
    const { background } = this.refs;

    if (background) {
      background.addEventListener("click", (e) => {
        e.preventDefault();
        if (!this.preventClose) {
          this.closeOverlay();
        }
      });
    }
  }

  handleEscapeKey() {
    this.escapeKeyHandler = (e) => {
      if (e.key === "Escape" || e.key === "Esc") {
        if (!this.preventClose) {
          this.closeOverlay();
        }
      }
    };

    document.addEventListener("keyup", this.escapeKeyHandler);
  }

  closeOverlay() {
    const { content, contentContainer } = this.refs;

    body.classList.remove(classes.overlayOpen);

    // Re-enable body scroll
    enableBodyScroll(contentContainer);

    // Destroy content behaviors
    if (content) {
      destroyBehaviors(content);
    }

    // Unset preventClose
    this.preventClose = false;

    // Unbind escape key handler
    document.removeEventListener("keyup", this.escapeKeyHandler);
  }

  cleanup() {
    const { contentContainer } = this.refs;

    window.removeEventListener(events.OPEN_OVERLAY, this.openHandler);
    document.removeEventListener("keyup", this.escapeKeyHandler);
    enableBodyScroll(contentContainer);
  }
}
